import type { GridOptions } from '../../../components/ui/table';
import { commonGridOptions, commonTextFilterParams } from '../../../lib/agGridOptions';
import {
  GRID_PAGE_SIZE,
  GRID_PAGE_SIZE_SELECTOR,
} from '../../../components/shared/agGridCells';
import type { AuditLogRow } from '../models/types';

export { GRID_PAGE_SIZE, GRID_PAGE_SIZE_SELECTOR };

/**
 * Header-funnel filters are UI-only. `doesFilterPass` always returns true so AG Grid does not
 * hide rows client-side — the list POST is the source of truth.
 */
const passServerSideFilter = () => true;

export const AUDIT_LOG_GRID_DEFAULT_COL_DEF = {
  resizable: true,
  filter: {
    component: 'agTextColumnFilter',
    doesFilterPass: passServerSideFilter,
  },
  filterParams: {
    ...commonTextFilterParams,
    filterOptions: ['contains'],
  },
};

export const auditLogGridOptions = {
  ...commonGridOptions,
  getRowId: (params) => params.data?.id ?? '',
  tooltipShowDelay: 300,
  tooltipShowMode: 'standard',
  tooltipInteraction: true,
  overlayNoRowsTemplate:
    '<span class="text-sm text-muted-foreground">No audit logs match the current filters.</span>',
} satisfies GridOptions<AuditLogRow>;
